import Lists from './Lists';

export default Lists;
